import { darken, getValue } from "../../utils.js";

export const APP_HYPERLINK = {
  "Hyperlink.Space.Around": {
    defaultValue: "default"
  },
  "Hyperlink.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Hyperlink.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Hyperlink.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Hyperlink.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Hyperlink.Height.Type": {
    defaultValue: "fixed"
  },

  "Hyperlink.Font.Size": {
    ref: "Font.Size.14"
  },
  "Hyperlink.Color": {
    ref: "Color.Primary.500"
  },
  "Hyperlink.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Hyperlink.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Hyperlink.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Hyperlink.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Hyperlink.Border.Color": {
    ref: "Color.Transparent"
  },
  "Hyperlink.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Hyperlink.Border.Style": {
    defaultValue: "solid"
  },
  "Hyperlink.Padding.Top": {
    defaultValue: "0px"
  },
  "Hyperlink.Padding.Right": {
    defaultValue: "0px"
  },
  "Hyperlink.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Hyperlink.Padding.Left": {
    defaultValue: "0px"
  },
  "Hyperlink.Hover.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Hyperlink.Hover.Color": {
    defaultRef: "Color.Primary.500",
    valueFunc: (meta) => darken(getValue("Hyperlink.Color", meta), 0.5)
  },
  "Hyperlink.Hover.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Hyperlink.Hover.Border.Color": {
    ref: "Color.Transparent"
  },
  "Hyperlink.Font.Style": {
    defaultValue: "normal"
  },
  "Hyperlink.Text.Decoration": {
    defaultValue: "none"
  },
  "Hyperlink.Width": {
    defaultValue: "auto"
  },
  "Hyperlink.Height": {
    defaultValue: "auto"
  },
  "Hyperlink.Min.Height": {
    defaultValue: "0px"
  },
  "Hyperlink.Min.Width": {
    defaultValue: "0px"
  },
  "Hyperlink.Max.Height": {
    defaultValue: "unset"
  },
  "Hyperlink.Max.Width": {
    defaultValue: "unset"
  },
  "Hyperlink.Margin.Top": {
    defaultValue: "0px"
  },
  "Hyperlink.Margin.Right": {
    defaultValue: "0px"
  },
  "Hyperlink.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Hyperlink.Margin.Left": {
    defaultValue: "0px"
  },
  "Hyperlink.Overflow": {
    defaultValue: "auto"
  },
  "Hyperlink.Cursor": {
    defaultValue: "pointer"
  },
  "Hyperlink.Box.Sizing": {
    defaultValue: "border-box"
  }
};
